import axios from 'axios';
import { API_URL } from '../utils/config';
import { getToken } from './auth/authService';
import apiClient from '../utils/axiosConfig';

const getAuthHeader = async () => {
  const token = await getToken();
  return token ? { Authorization: `Token ${token}` } : {};
};

const _serverBase = () => API_URL.replace('/api/v1', '').replace('/api', '');

const userService = {
  // Obtener estadísticas del usuario
  getUserStats: async () => {
    try {
      const headers = await getAuthHeader();
      const response = await axios.get(`${API_URL.replace('/api/v1', '')}/api/auth/stats/`, {
        headers
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas del usuario:', error);
      return {
        missions: { total: 0, completed: 0, pending: 0, in_progress: 0 },
        reports: { total: 0, completed: 0, pending: 0, in_progress: 0 }
      };
    }
  },

  // Cambiar contraseña del usuario autenticado
  changePassword: async (currentPassword, newPassword) => {
    const url = `${_serverBase()}/erp/api/change-password/`;
    const response = await apiClient.post(url, {
      current: currentPassword,
      new_password: newPassword,
      app: 'amissionhub',
    });
    return response.data;
  },
};

export default userService;